<div class="flex flex-col flex-1 justify-between place-content-between h-full">
  <div class="border border-gray-300 flex flex-row rounded-lg pb-2 pt-2 items-center">
    <img class="h-9 w-9 ml-2 mr-2" [src]="selectedBank().logo" />
    <div class="flex flex-col">
      <p class="text-secondary font-bold text-sm">{{ selectedBank().name }}</p>
      <p class="text-secondary text-xs">{{ regionalBankName() }}</p>
    </div>
  </div>
  <div>
    <img class="m-auto" src="../../../../../assets/svg/loader.svg" alt="loader" />
    <p class="text-center mt-5">{{ 'thanks_to_authenticate_to_your_bank' | translate }}</p>
  </div>
  <div class="flex">
    <button
      class="bg-gray-100 font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6"
      (click)="backToBankChoice()"
    >
      {{ 'choose_another_bank' | translate }}
    </button>
  </div>
</div>
